import {DTStoreNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {locationCardSchema} from '../../../../../schemas/locationCardSchema';
import {z} from 'zod';

export function convertLocationAPICardToAICard(locationCard: DTStoreNode) {
  const card: z.input<typeof locationCardSchema> = {
    ...locationCard,
    cardId: locationCard.id,
    name: locationCard.name ?? '',
    description: locationCard.description ?? '',
    locationFeedId: locationCard.locationFeedId,
    locationSetId: locationCard.locationSetId ?? null,
    maxDistKm: locationCard.maxDistKm,
    topLocationIds: locationCard.topLocationIds ?? [],
    locationTargetingMethod: locationCard.locationTargetingMethod,
  } satisfies z.output<typeof locationCardSchema>;

  return card;
}
